import { z } from 'zod'

export const DnsRecordType = z.enum([
  'A',
  'AAAA',
  'CNAME',
  'MX',
  'TXT',
  'NS',
  'SRV',
  'CAA',
  'AFSDB',
  'ALIAS',
  'CERT',
  'HINFO',
  'HTTPS',
  'IPSECKEY',
  'LOC',
  'NAPTR',
  'OPENPGPKEY',
  'PTR',
  'RP',
  'SMIMEA',
  'SOA',
  'SSHFP',
  'SVCB',
  'TLSA',
  'URI',
  'URL'
])

export type DnsRecordType = z.infer<typeof DnsRecordType>

export const DnsRecord = z.object({
  id: z.number(),
  name: z.string(),
  type: DnsRecordType,
  content: z.string(),
  ttl: z.number().optional(),
  priority: z.number().optional()
})

export type DnsRecord = z.infer<typeof DnsRecord>

export const DnsRecordCreateRequest = z.object({
  type: DnsRecordType,
  content: z.string(),
  name: z.string().optional(),
  ttl: z.number().optional(),
  priority: z.number().optional()
})

export type DnsRecordCreateRequest = z.infer<typeof DnsRecordCreateRequest>

export const DnsRecordUpdateRequest = z.object({
  name: z.string().optional(),
  type: DnsRecordType.optional(),
  content: z.string().optional(),
  ttl: z.number().optional(),
  priority: z.number().optional()
})

export type DnsRecordUpdateRequest = z.infer<typeof DnsRecordUpdateRequest>
